import { useGetNewAuthTokenQuery } from '@/features/api/endpoints/digdashUserConfigEndpoints';

type Props = {
  skip?: boolean;
};

export const useGetNewAuthToken = ({ skip = false }: Props) => {
  const { data, error, isFetching, isLoading } = useGetNewAuthTokenQuery(undefined, {
    skip,
  });

  return {
    data,
    error,
    isLoading: isLoading || isFetching,
  };
};
